<template>
  <canvas :id="id"/>
</template>

<script>
import Chart from 'chart.js'
export default {
  name: 'PieChart',
  props: {
    labels: {
      type: Array,
      default () {
        return []
      }
    },
    datasets: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      id: this.generateId(),
      chart: null,
      ctx: null
    }
  },
  watch: {
    labels () {
      this.chart.data.labels = this.labels
      this.chart.update()
    },
    datasets () {
      this.chart.data.datasets = this.datasets
      this.chart.update()
    }
  },
  mounted () {
    this.chart = new Chart(this.id, {
      type: 'pie',
      data: {
        labels: this.labels,
        datasets: this.datasets
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'top',
          labels: {
            boxWidth: 15,
            fontColor: 'black',
            fontFamily: 'Open Sans',
            fontSize: 13,
            padding: 10
          }
        }
      }
    })
  },
  beforeDestroy () {
    this.chart.destroy()
  },
  methods: {
    generateId () {
      return '_' + Math.random().toString(36).substr(2, 9)
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/_shared/charts/pie-chart.vue